import React from 'react';

const AuthContext = React.createContext({
  isAuthenticated: false,
  isTokenInvalid: false,
  isBootstrapping: true,
  user: null,
  accessToken: null,
  idToken: null,
  scope: '',
  expiresAt: 0,
  logout: () => {},
  getAccessToken: () => null,
});

export default AuthContext;

